/* eslint-disable object-curly-newline */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
/* eslint-disable no-confusing-arrow */
/* eslint-disable import/no-cycle */

import React from "react";

import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Divider from "@mui/material/Divider";

import AlarmOnIcon from "@mui/icons-material/AlarmOn";

import {
    CAREER_TYPE_ELEARNING,
    CAREER_TYPE_CLASSROOM,
    CAREER_STATUS_APPLYING_ATTEND,
    CAREER_STATUS_APPLYING_CANCEL,
    CAREER_STATUS_APPLYING_RECORD,
    CAREER_STATUS_APPLYING_EXECUTE,
    CAREER_STATUS_DOING,
    CAREER_STATUS_LEARNING,
    CAREER_STATUS_UNLEARNED,
    CareerStatuses,
    CAREER_STATUS_COMPLETED,
    CAREER_STATUS_NOT_COMPLETED,
    CURRICULUM_STATUS_APPLYING_ATTEND,
    CURRICULUM_STATUS_DOING,
    CURRICULUM_STATUS_CANCEL_LEARN,
    CURRICULUM_STATUS_COMPLETED,
    CURRICULUM_STATUS_INVALID,
} from "../../Constants";

import CareerCard from "../../component/card/CareerCard";
import CurriculumCard from "../../component/card/CurriculumCard";
import SompoCardContent from "../../component/card/SompoCardContent";
import SompoProgressBar from "../../component/progress/SompoProgressBar";
import FilterTag, { ALL_CONDITION } from "../../component/filter/FilterTag";
import NoData from "../../component/NoData";
import SompoLoading from "../../component/loading/SompoLoading";

import SompoContext from "../../logic/context/SompoContext";
import { formatPeriod, separateStartAndEndDate, parseJSDateTime, DateFormats } from "../../logic/datetime";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import { replaceCurriculaStatus } from "../../logic/utility/replaceLabels";
import { chainedSort, asc, descDate } from "../../logic/utility/sort";
import { alertDays, statusMatches } from "../../logic/utility/TrainingUtil";

import { CareerHistoryProfile, CurriculumHistoryProfile } from "./Profile";

// Interfaces/Types
interface CustomTabProps {
    tabIndex: number;
    name: string;
    children?: React.ReactNode;
    selected: boolean;
}

const createCustomTabProps = (constant: TabConstant, content: React.ReactNode, selectedTab: number, showCurriculums?: boolean) =>
    showCurriculums === undefined || showCurriculums
        ? ({
            tabIndex: constant.tabIndex,
            name: constant.name,
            selected: constant.tabIndex === selectedTab,
            children: content,
        } as CustomTabProps)
        : null;

// Domestic constants.
const APPLYING = "申請中";
const DOING = "受講中";
const RESULT = "完了";

interface TabConstant {
    tabIndex: number;
    name: string;
}
const TabConstants: { [key: string]: TabConstant } = {
    career: {
        tabIndex: 0,
        name: "講座",
    },
    curriculum: {
        tabIndex: 1,
        name: "カリキュラム",
    },
};

// Sub components.
// タブ
const TabLabel = (props: Partial<CustomTabProps>) => {
    const { name, selected } = props;
    return (
        <Typography variant="h6" fontWeight={selected ? "bold" : "normal"} sx={{ color: selected ? "secondary" : "#999999" }}>
            {name}
        </Typography>
    );
};
const toTab = (props: Partial<CustomTabProps> | null) =>
    props && (
        <Tab
            key={`Profile-History-Tab-${props.tabIndex}`}
            label={<TabLabel {...props} />}
            sx={{
                width: "auto",
                borderRadius: "6px 6px 0 0",
                transition: "0.3s",
                "&:hover": {
                    opacity: "0.7",
                },
                p: 1,
            }}
        />
    );
const renderTabs = (tabs: Array<CustomTabProps | null>) => tabs.map((tabProps) => toTab(tabProps));

// タブ内容
const CustomTabPanel = (props: Partial<CustomTabProps>) => {
    const { tabIndex, children, selected } = props;
    return (
        <Box
            id={`Profile-History-TabPanel-${tabIndex}`}
            hidden={!selected}
            sx={{
                height: { xs: "auto", sm: "auto", md: "auto" },
                width: "100%",
                maxWidth: "100%",
            }}
        >
            {selected && (
                <Box sx={{ width: "100%" }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        sx={{
                            height: "auto",
                            flexWrap: "wrap",
                            rowGap: 1,
                            width: "100%",
                            py: 1,
                        }}
                    >
                        {children}
                    </Grid>
                </Box>
            )}
        </Box>
    );
};
const toPanel = (props: Partial<CustomTabProps> | null) =>
    props && <CustomTabPanel key={`Profile-History-CustomTabPanel-${props.tabIndex}`} {...props} />;
const renderPanels = (tabs: Array<CustomTabProps | null>) => tabs.map((tabProps) => toPanel(tabProps));

// フィルタ
const Filters = (props: { filter: string; handleFilterChange: (name: string, id: string) => void }) => {
    // Props.
    const { filter, handleFilterChange } = props;

    // Theme.
    const theme = useTheme();

    const conditions = [
        { name: ALL_CONDITION.name, id: ALL_CONDITION.id },
        { name: APPLYING, id: APPLYING, dotColor: theme.palette.primary.main },
        { name: DOING, id: DOING, dotColor: theme.palette.primary.main },
        { name: RESULT, id: RESULT, dotColor: "#36AA00" },
    ];

    return <FilterTag conditionList={conditions} value={filter} handleChange={handleFilterChange} />;
};

// 講座
const ProfileCareerCard = (props: { row: CareerHistoryProfile }) => {
    // Props.
    const { row } = props;

    // Hooks.
    const navigate = useNavigate();

    const { alertView, remainingDays } = alertDays(row);
    return (
        <Grid sx={{ mx: 0.3, mb: 0.5 }}>
            <CareerCard
                thumbnail={row.careerImageUrl}
                tooltip={row.careerTitle}
                height="312px"
                badge={row.compulsoryId}
                onClick={() => {
                    navigate(`/training/detail/${row.careerId}`, { state: { classId: row.classId } });
                }}
            >
                <SompoCardContent
                    sx={{
                        width: "100%",
                        height: "auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        textAlign: "left",
                    }}
                >
                    <Typography
                        sx={{
                            minHeight: "2lh",
                            wordBreak: "break-all",
                            overflowX: "hidden",
                            width: "100%",
                            fontSize: "1rem",
                            fontWeight: "bold",
                        }}
                        className="ellipses2"
                    >
                        {row.careerTitle}
                    </Typography>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        sx={{
                            visibility: alertView ? "visible" : "hidden",
                            width: "5.5em",
                            bgcolor: "#FFA800",
                            px: 0.5,
                            borderRadius: "1rem",
                            my: 0.5,
                            color: "white",
                            fontSize: "0.8rem",
                            minHeight: "1.3rem",
                        }}
                    >
                        {/** 期限アラート eラーニング、残り0~7日の時のみ表示 */}
                        {alertView && (
                            <>
                                <AlarmOnIcon sx={{ fontSize: "1em", mr: "2px" }} />
                                <Typography sx={{ fontWeight: "bold" }}>{`残り${remainingDays}日`}</Typography>
                            </>
                        )}
                    </Grid>
                    <Typography
                        sx={{
                            fontSize: "13px",
                            color: "#444C55",
                            minHeight: { md: "20px", sm: "43px", xs: "36px" },
                        }}
                    >
                        {formatPeriod(row.jissiKikan)}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "13px",
                            color: "#444C55",
                        }}
                    >
                        {row.careerTypeId === CAREER_TYPE_ELEARNING ? "e-ラーニング" : "集合研修"}
                    </Typography>
                    {row.careerTypeId === CAREER_TYPE_ELEARNING && row.progress && (
                        <Grid item sx={{ mt: 1 }}>
                            <SompoProgressBar progress={row.progress} />
                        </Grid>
                    )}
                    {row.careerTypeId === CAREER_TYPE_CLASSROOM && row.classroom && (
                        <Typography
                            className="ellipses"
                            sx={{
                                fontSize: "13px",
                                color: "#444C55",
                                wordBreak: "break-all",
                                overflowX: "hidden",
                            }}
                        >
                            {row.classroom}
                        </Typography>
                    )}
                </SompoCardContent>
            </CareerCard>
        </Grid>
    );
};
const toCareerCard = (row: CareerHistoryProfile, index: number) => (
    <ProfileCareerCard row={row} key={`Profile-History-Career-Card-${row.careerId}-${index}`} />
);
const toCareerCards = (careers: CareerHistoryProfile[]) => careers.map((row, index) => toCareerCard(row, index));

const filterCareersByStatus = (career: CareerHistoryProfile, filterValue: string): boolean => {
    const { status } = career;
    switch (filterValue) {
        case APPLYING:
            return statusMatches(status, [
                CareerStatuses[CAREER_STATUS_APPLYING_ATTEND], // 受講申請中
                CareerStatuses[CAREER_STATUS_APPLYING_EXECUTE], // 実施申請中(受講申請中として扱う)
                CareerStatuses[CAREER_STATUS_APPLYING_CANCEL], // 取消申請中
                CareerStatuses[CAREER_STATUS_APPLYING_RECORD], // 実績申請中
            ]);
        case DOING:
            return statusMatches(status, [
                CareerStatuses[CAREER_STATUS_UNLEARNED], // 未学習
                CareerStatuses[CAREER_STATUS_LEARNING], // 学習中
                CareerStatuses[CAREER_STATUS_DOING], // 実施中(学習中として扱う)
            ]);
        case RESULT:
            return statusMatches(status, [
                CareerStatuses[CAREER_STATUS_COMPLETED], // 修了
                CareerStatuses[CAREER_STATUS_NOT_COMPLETED], // 未修了
            ]);
        default:
            return true;
    }
};
const filterCareers = (careers: CareerHistoryProfile[], filterValue: string) =>
    (careers || [])
        .filter(
            // フィルタリング
            (career) => filterCareersByStatus(career, filterValue)
        )
        .sort(
            // ソート
            (a, b) =>
                chainedSort(
                    a,
                    b,
                    // 1. 終了日(降順)
                    (_a, _b) => {
                        const parse = (c: CareerHistoryProfile) => {
                            const { endDate } = separateStartAndEndDate(c.jissiKikan);
                            return parseJSDateTime(endDate);
                        };
                        const endA = parse(_a);
                        const endB = parse(_b);
                        return descDate(endA, endB);
                    },
                    // 2. 講座名(昇順)
                    (_a, _b) => asc(_a.careerTitle, _b.careerTitle)
                )
        );

const Careers = (props: { filter: string; careerHistories: CareerHistoryProfile[] }) => {
    // Context
    const sompoContext = React.useContext(SompoContext);

    // Props.
    const { filter, careerHistories } = props;

    // States.
    const [careers, setCareers] = React.useState<CareerHistoryProfile[]>([]);

    // Side effects.
    React.useEffect(() => {
        try {
            // フィルター・ソート
            const _careers = filterCareers(careerHistories, filter);
            setCareers(_careers);
        } catch (error: any) {
            console.error(error);
            showErrorMessage({ message: "受講履歴の取得に失敗しました。", error });
            setCareers([]);
        }
    }, [filter, careerHistories]);

    // Render component.
    // fetchが終わるまでローディングアイコンを表示
    if (sompoContext.loading) return <SompoLoading position="relative" mt={10} />;
    // 表示データが無いとき
    if (!(careers || []).length) return <NoData message="表示データがありません" />;
    // 表示データあり
    return toCareerCards(careers);
};

// カリキュラム
const ProfileCurriculumCard = (props: { row: CurriculumHistoryProfile }) => {
    const { row } = props;
    const navigate = useNavigate();

    const status = React.useMemo(() => replaceCurriculaStatus(row.status), [row.status]);

    return (
        <>
            <Grid sx={{ mx: 0.3, mb: 0.5 }}>
                <CurriculumCard tooltip={row.careerTitle} badge={row.compulsoryId} onClick={() => navigate(`/curriculum/detail/${row.careerId}`)}>
                    <SompoCardContent
                        sx={{
                            display: "flex",
                            gap: 0.4,
                            flexFlow: "column",
                            justifyContent: "flex-start",
                            textAlign: "left",
                        }}
                    >
                        <Box />
                        <Typography
                            sx={{
                                width: "100%",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                minHeight: "2lh",
                                wordBreak: "break-all",
                                overflowX: "hidden",
                            }}
                            className="ellipses2"
                        >
                            {row.careerTitle}
                        </Typography>
                        <Typography variant="body2">カリキュラム</Typography>
                        <Typography variant="body2">{`${row.credit || "0/0"} 単位`}</Typography>
                        <Typography variant="body2">{status}</Typography>
                    </SompoCardContent>
                </CurriculumCard>
            </Grid>
        </>
    );
};

const toCurriculumCard = (row: CurriculumHistoryProfile, index: number) => (
    <ProfileCurriculumCard row={row} key={`Profile-History-Curriculum-Card-${row.careerId}-${index}`} />
);
const toCurriculumCards = (curriculums: CurriculumHistoryProfile[]) => curriculums.map((row, index) => toCurriculumCard(row, index));

const filterCurriculumsByStatus = (curriculum: CurriculumHistoryProfile, filterValue: string): boolean => {
    const { statusId = "" } = curriculum;
    switch (filterValue) {
        case APPLYING: // 申請中：受講申請中、受講取消のみ表示
            return statusMatches(statusId, [CURRICULUM_STATUS_APPLYING_ATTEND, CURRICULUM_STATUS_CANCEL_LEARN]);
        case DOING: // 受講中：実施中のみ表示
            return statusId === CURRICULUM_STATUS_DOING;
        case RESULT: // 完了：修了、失効のみ表示
            return statusMatches(statusId, [CURRICULUM_STATUS_COMPLETED, CURRICULUM_STATUS_INVALID]);
        default:
            return true;
    }
};
const filterCurriculums = (onGoing: CurriculumHistoryProfile[], result: CurriculumHistoryProfile[], filterValue: string) => {
    const curriculums = [...(onGoing || []), ...(result || {})];
    return curriculums
        .filter(
            // フィルタリング: ステータス
            (curriculum) => filterCurriculumsByStatus(curriculum, filterValue)
        )
        .sort(
            // ソート
            (a, b) =>
                chainedSort(
                    a,
                    b,
                    // 1. カリキュラムID(昇順)
                    (_a, _b) => asc(_a.careerId, _b.careerId),
                    // 2. 修了日(昇順)
                    (_a, _b) => {
                        const parse = (c: CurriculumHistoryProfile) => parseJSDateTime(c.complDate, DateFormats.YYYYMMDDHHMM);
                        const completeA = parse(_a);
                        const completeB = parse(_b);
                        return descDate(completeA, completeB);
                    }
                )
        );
};

const Curriculums = (props: { filter: string; onGoingCurriculums: CurriculumHistoryProfile[]; resultCurriculums: CurriculumHistoryProfile[] }) => {
    // Context.
    const sompoContext = React.useContext(SompoContext);

    // Props.
    const { filter, onGoingCurriculums, resultCurriculums } = props;

    // States.
    const [curriculums, setCurriculums] = React.useState<CurriculumHistoryProfile[]>([]);

    // Side effects.
    React.useEffect(() => {
        try {
            // フィルター・ソート
            const _curriculums = filterCurriculums(onGoingCurriculums, resultCurriculums, filter);
            setCurriculums(_curriculums);
        } catch (error: any) {
            console.error(error);
            showErrorMessage({ message: "受講履歴の取得に失敗しました。", error });
            setCurriculums([]);
        }
    }, [filter, onGoingCurriculums, resultCurriculums]);

    // Render component.
    // fetchが終わるまでローディングアイコンを表示
    if (sompoContext.loading) return <SompoLoading position="relative" mt={10} />;
    // 表示データが無いとき
    if (!(curriculums || []).length) return <NoData message="表示データがありません" />;
    // 表示データあり
    return toCurriculumCards(curriculums);
};

// Main component.
const History = (props: {
    careers: CareerHistoryProfile[];
    onGoingCurriculums: CurriculumHistoryProfile[];
    resultCurriculums: CurriculumHistoryProfile[];
    showCurriculums: boolean;
}) => {
    const { careers, onGoingCurriculums, resultCurriculums, showCurriculums } = props;

    // States.
    const [selectedTab, setSelectedTab] = React.useState(TabConstants.career.tabIndex);
    const [filter, setFilter] = React.useState(ALL_CONDITION.id);

    // Context
    const sompoContext = React.useContext(SompoContext);

    // Event handlers.
    // タブ変更時
    const handleTabChanged = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
        setFilter(ALL_CONDITION.id);
    };

    // フィルタ変更時
    const handleFilterChanged = (name: string, id: string) => {
        setFilter(id);
    };

    // タブの定義
    const tabs = [
        createCustomTabProps(TabConstants.career, <Careers {...{ filter, careerHistories: careers }} />, selectedTab),
        createCustomTabProps(
            TabConstants.curriculum,
            <Curriculums {...{ filter, onGoingCurriculums, resultCurriculums }} />,
            selectedTab,
            showCurriculums
        ),
    ];

    // Render main component.
    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    pl: { xs: 2, sm: 2, md: 4 },
                    pr: { xs: 2, sm: 2, md: 4 },
                    pt: 2,
                    pb: 1,
                    mb: 1,
                    pointerEvents: sompoContext.loading ? "none" : "auto",
                }}
            >
                <Typography variant="h3">{"受講履歴"}</Typography>
                {showCurriculums && (
                    <Box sx={{ width: "100%" }}>
                        <Tabs
                            value={selectedTab}
                            onChange={handleTabChanged}
                            sx={{
                                minHeight: "50px",
                                height: "50px",
                                borderBottom: "2px solid #E9EEF5",
                            }}
                            textColor="secondary"
                            indicatorColor="secondary"
                        >
                            {/* タブのレンダリング */}
                            {renderTabs(tabs)}
                        </Tabs>
                    </Box>
                )}
                {!showCurriculums && <Divider sx={{ mt: 2, mb: 2 }} />}
                <Filters filter={filter} handleFilterChange={handleFilterChanged} />
            </Paper>

            {/* タブ内容のレンダリング */}
            {renderPanels(tabs)}
        </>
    );
};

export default History;
